import React, { useState } from 'react';
import { Modal } from 'antd';
import { BaseCardContent } from '../MessageType';
import { isVideoUrl } from '../MessageUtil';

interface ImageCardViewProps {
  content: BaseCardContent;
}

export const ImageCardView: React.FC<ImageCardViewProps> = ({ content }) => {
  const [preview, setPreview] = useState(false);
  const url = (content.url as string) || '';
  const width = Math.min(Number(content.width) || 160, 240);
  const height = Math.min(Number(content.height) || 160, 240);

  if (!url) {
    return <div className="message-image-placeholder">图片加载中</div>;
  }

  if (isVideoUrl(url)) {
    return (
      <video
        src={url}
        controls
        style={{ maxWidth: width, maxHeight: height, borderRadius: 4 }}
      />
    );
  }

  return (
    <>
      <img
        src={url}
        alt=""
        style={{
          maxWidth: width,
          maxHeight: height,
          borderRadius: 4,
          cursor: 'pointer',
          display: 'block',
        }}
        onClick={() => setPreview(true)}
      />
      <Modal
        open={preview}
        footer={null}
        onCancel={() => setPreview(false)}
        centered
        width="auto"
        styles={{ body: { padding: 0, background: '#000' } }}
      >
        <img src={url} alt="" style={{ maxWidth: '90vw', maxHeight: '85vh' }} />
      </Modal>
    </>
  );
};
